import { createFileRoute } from '@tanstack/react-router'
import { CompanyBankAccountsPage } from '@/features/company-bank-accounts'

export const Route = createFileRoute('/_authenticated/personal-bank-accounts/')({
  component: () => <CompanyBankAccountsPage type='personal' />,
})
